import { useState, useEffect } from 'react';
import { TemplateBrowser } from './components/TemplateBrowser';
import { MemeEditor } from './components/MemeEditor';
import { ProjectsList } from './components/ProjectsList';
import { Header } from './components/Header';

export type View = 'templates' | 'editor' | 'projects';

function App() {
  // Initialize view from URL
  const getInitialView = (): View => {
    const params = new URLSearchParams(window.location.search);
    const view = params.get('view');
    if (view === 'projects' || view === 'editor') return view;
    return 'templates';
  };

  const [currentView, setCurrentView] = useState<View>(getInitialView());
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [selectedProject, setSelectedProject] = useState<any>(null);

  // Update URL when view changes
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (currentView === 'templates') {
      params.delete('view');
    } else {
      params.set('view', currentView);
    }
    const newUrl = params.toString() ? `?${params.toString()}` : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
  }, [currentView]);

  const handleTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
    setSelectedProject(null);
    setCurrentView('editor');
  };

  const handleProjectSelect = (project: any) => {
    setSelectedProject(project);
    setSelectedTemplate(null);
    setCurrentView('editor');
  };

  const handleBackToTemplates = () => {
    setCurrentView('templates');
    setSelectedTemplate(null);
    setSelectedProject(null);
  };

  const handleViewChange = (view: View) => {
    setCurrentView(view);
    if (view !== 'editor') {
      setSelectedTemplate(null);
      setSelectedProject(null);
    }
  };

  return (
    <div className="min-h-screen">
      <Header
        currentView={currentView}
        onViewChange={handleViewChange}
      />

      <main className="container mx-auto px-4 py-12">
        {currentView === 'templates' && (
          <TemplateBrowser onSelectTemplate={handleTemplateSelect} />
        )}

        {currentView === 'editor' && (
          <MemeEditor
            template={selectedTemplate}
            project={selectedProject}
            onBack={handleBackToTemplates}
          />
        )}

        {currentView === 'projects' && (
          <ProjectsList onSelectProject={handleProjectSelect} />
        )}
      </main>
    </div>
  );
}

export default App;
